import controller from './chart-water-detector.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};
